// Mintlify writes a diagram as a plain fence: ```mermaid placement="top-left"

interface TurndownLike {
	addRule: (
		key: string,
		rule: {
			filter: (node: Node) => boolean
			replacement: (content: string, node: Node) => string
		},
	) => void
}

const isMermaid = (node: Node): boolean =>
	node.nodeName === "DIV" &&
	(node as HTMLElement).getAttribute("data-type") === "mermaid"

// A source holding its own ``` run needs a longer fence around it.
export function fenceFor(source: string): string {
	const longest = Math.max(
		0,
		...[...source.matchAll(/`{3,}/g)].map((match) => match[0].length),
	)
	return "`".repeat(Math.max(3, longest + 1))
}

export function mermaidFence(
	source: string,
	attributes: { placement?: string | null; actions?: string | null } = {},
): string {
	const props = [
		attributes.placement ? `placement="${attributes.placement}"` : "",
		attributes.actions === "true" || attributes.actions === "false"
			? `actions={${attributes.actions}}`
			: "",
	]
		.filter(Boolean)
		.join(" ")
	const fence = fenceFor(source)
	return `${fence}mermaid${props ? ` ${props}` : ""}\n${source.replace(/\n+$/, "")}\n${fence}`
}

export function addMermaidMarkdownRules(turndown: TurndownLike): void {
	turndown.addRule("mermaid", {
		filter: isMermaid,
		replacement: (_content, node) => {
			const element = node as HTMLElement
			const pre = element.querySelector("pre")
			const source = (pre?.querySelector("code") ?? pre)?.textContent ?? ""
			return `\n\n${mermaidFence(source, {
				placement: element.getAttribute("data-placement"),
				actions: element.getAttribute("data-actions"),
			})}\n\n`
		},
	})
}
